var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 75,
    viewBox: "0 0 90 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1062 43.5411L49.6713 73.3605C46.9227 75.5465 43.0644 75.5465 40.3158 73.3605L2.89376 43.528C-0.964585 40.4518 -0.964585 34.522 2.89376 31.4589L40.3287 1.63954C43.0773 -0.546514 46.9356 -0.546514 49.6842 1.63954L87.1062 31.472C90.9646 34.5482 90.9646 40.478 87.1062 43.5411Z",
    fill: "#F71C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2246 33.0428H32.4055C35.7348 32.9905 38.0705 35.386 38.0189 38.5407C38.0705 41.6954 35.7219 44.0778 32.4055 44.0386H28.2246V33.0428ZM32.1862 42.1012C34.5864 42.1012 35.9155 40.6875 35.9155 38.5538C35.9155 36.4201 34.5864 34.9671 32.1862 34.9671H30.2764V42.1012H32.1862Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2907 33.0433V34.9675H43.1033V37.5332H47.8391V39.4313H43.1033V42.1017H48.2907V44.039H41.0645V33.0433H48.2907ZM43.9163 31.9699L42.1226 29.666H44.5485L45.4519 31.9699H43.9163Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2905 33.043H52.6003L55.8651 40.4258L59.1299 33.043H61.4397L56.4587 44.1303H55.2844L50.3034 33.043H50.2905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.8125fd39ffc874d73c784f421403fda5.svg";
export { ForwardRef as ReactComponent };